import { HTTP } from '@/utils/http';
import * as actionTypes from '../types/actions';
import * as getterTypes from '../types/getters';
import * as mutationTypes from '../types/mutations';

export default {
  actions: {
    async [actionTypes.DO_GET_STAFF_MEMBER]({ commit }, payload) {
      const { id, ...params } = payload;
      const { data } = await HTTP.get(`/staff_members/${id}`, { params });
      commit(mutationTypes.SET_STAFF_MEMBER, data.data.staff_members[0]);
      return data;
    },
    async [actionTypes.DO_GET_STAFF_MEMBERS]({ commit }, params) {
      const { data } = await HTTP.get('/staff_members', { params });
      commit(mutationTypes.SET_STAFF_MEMBERS, data.data.staff_members);
      return data;
    },
  },
  getters: {
    [getterTypes.GET_STAFF_MEMBER]: state => state.staffMember,
    [getterTypes.GET_STAFF_MEMBERS]: state => state.staffMembers,
  },
  mutations: {
    [mutationTypes.SET_STAFF_MEMBER](state, staffMember) {
      state.staffMember = staffMember;
    },
    [mutationTypes.SET_STAFF_MEMBERS](state, staffMembers) {
      state.staffMembers = staffMembers;
    },
  },
  state: {
    staffMember: {},
    staffMembers: [],
  },
};
